import {
  Group,
  Object3D,
  PerspectiveCamera,
  Scene,
  WebGLRenderer,
} from "three";

import { parseUrlQuery } from "../../../utils/url";
import { EffectComposer } from "three/examples/jsm/postprocessing/EffectComposer";
import { RenderPass } from "three/examples/jsm/postprocessing/RenderPass";
import { UnrealBloomPass } from "three/examples/jsm/postprocessing/UnrealBloomPass";
import { ShaderPass } from "three/examples/jsm/postprocessing/ShaderPass";

interface BaseScene {
  build(): void;
  update?(timestamp: number): void;
}

abstract class BaseScene {
  scene = new Scene();
  camera = new PerspectiveCamera();
  transition;
  renderer!: WebGLRenderer;
  container: Object3D | undefined;
  selectedObjects: Object3D[] = [];
  postProcess:
    | {
        composer: EffectComposer;
        bloomComposer: EffectComposer;
        renderPass: RenderPass;
        bloomPass: UnrealBloomPass;
        fxaaPass: ShaderPass;
      }
    | undefined;
  sizes:
    | {
        width: number;
        height: number;
        pixelRatio: number;
      }
    | undefined;

  public transitionGroup = new Group();

  abstract start: () => void;
  abstract pause: () => void;
  abstract resume: () => void;
  abstract stop: () => void;
  abstract animate: () => void;

  debugMode: boolean;

  protected constructor(readonly canvas: HTMLCanvasElement) {
    // this.debugMode = parseUrlQuery().debugScene === "true";
    this.debugMode = false;
  }

  resize() {
    const width = window.innerWidth;
    const height = window.innerHeight;
    this.renderer?.setSize(width, height);
    this.camera.aspect = width / height;
    this.camera.updateProjectionMatrix();

    if (this.postProcess && this.postProcess.bloomComposer && this.postProcess.composer) {
      this.postProcess.bloomComposer.setSize( width, height );
      this.postProcess.composer.setSize( width, height );
    }

    if (this.postProcess && this.postProcess.fxaaPass && this.postProcess.composer) {
      const pixelRatio = this.renderer.getPixelRatio();
      this.postProcess.fxaaPass.material.uniforms[ 'resolution' ].value.x = 1 / ( width * pixelRatio );
      this.postProcess.fxaaPass.material.uniforms[ 'resolution' ].value.y = 1 / ( height * pixelRatio );
    }
  }

  render = () => {
    if (!this.renderer) return;

    this.animate();
  };
}

export { BaseScene };
